/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList';
import themeConfig, { colors } from '@/../themeConfig.js';
import versionJson from '../../public/version.json';
import localForage from 'localforage';

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  //uid         : 0,          // From Auth
  //displayName : 'John Doe', // From Auth
  //about       : 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  //photoURL    : require('@/assets/images/portrait/small/avatar-s-11.jpg'), // From Auth
  //status      : 'online',
  //userRole    : 'admin'
};

const trialDefaults = {
  //uid         : 0,          // From Auth
  //displayName : 'John Doe', // From Auth
  //about       : 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  //photoURL    : require('@/assets/images/portrait/small/avatar-s-11.jpg'), // From Auth
  //status      : 'online',
  //userRole    : 'admin'
};

const fundingDefaults = {
  //uid         : 0,          // From Auth
  //displayName : 'John Doe', // From Auth
  //about       : 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  //photoURL    : require('@/assets/images/portrait/small/avatar-s-11.jpg'), // From Auth
  //status      : 'online',
  //userRole    : 'admin'
};
const loanDefaults = {};

const downloadDefaults = {
  status: '',
};

const uploadDefaults = {
  status: '',
};

const exportDefaults = {
  status: '',
};
const exportReplenishmentDefaults = {
  status: '',
};

const marketplace = localStorage.getItem('marketplace');
const store = localStorage.getItem('store');

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = async () => {
  const userInfoLocalStorage = (await localForage.getItem('userInfo')) || {};
  const userInfo = {};

  // Update property in user
  Object.keys(userDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    userInfo[key] = userInfoLocalStorage[key]
      ? userInfoLocalStorage[key]
      : userDefaults[key];
  });

  // Include properties from localStorage
  Object.keys(userInfoLocalStorage).forEach((key) => {
    if (userInfo[key] === undefined && userInfoLocalStorage[key] !== null)
      userInfo[key] = userInfoLocalStorage[key];
  });

  return userInfo;
};

const trialInfoLocalStorage = JSON.parse(localStorage.getItem('trial')) || {};

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getStoreTrialInfo = () => {
  const trialInfo = {};

  // Update property in user
  Object.keys(trialDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    trialInfo[key] = trialInfoLocalStorage[key]
      ? trialInfoLocalStorage[key]
      : trialDefaults[key];
  });

  // Include properties from localStorage
  Object.keys(trialInfoLocalStorage).forEach((key) => {
    if (trialInfo[key] === undefined && trialInfoLocalStorage[key] !== null)
      trialInfo[key] = trialInfoLocalStorage[key];
  });

  return trialInfo;
};

const fundingInfoLocalStorage =
  JSON.parse(localStorage.getItem('funding')) || {};
const loanInfoLocalStorage = JSON.parse(localStorage.getItem('loan')) || {};

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getStoreFundingInfo = () => {
  const fundingInfo = {};

  // Update property in user
  Object.keys(fundingDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    fundingInfo[key] = fundingInfoLocalStorage[key]
      ? fundingInfoLocalStorage[key]
      : fundingDefaults[key];
  });

  // Include properties from localStorage
  Object.keys(trialInfoLocalStorage).forEach((key) => {
    if (fundingInfo[key] === undefined && fundingInfoLocalStorage[key] !== null)
      fundingInfo[key] = fundingInfoLocalStorage[key];
  });

  return fundingInfo;
};

const getStoreLoanInfo = () => {
  const loanInfo = {};

  // Update property in user
  Object.keys(loanDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    loanInfo[key] = loanInfoLocalStorage[key]
      ? loanInfoLocalStorage[key]
      : loanDefaults[key];
  });

  // Include properties from localStorage
  Object.keys(trialInfoLocalStorage).forEach((key) => {
    if (loanInfo[key] === undefined && loanInfoLocalStorage[key] !== null)
      loanInfo[key] = loanInfoLocalStorage[key];
  });

  return loanInfo;
};

const downloadInfoLocalStorage = localStorage.getItem('downloadInfo') || {};

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getDownloadInfo = () => {
  const downloadInfo = {};

  //console.log('downloadInfoLocalStorage',downloadInfoLocalStorage);

  // Update property in user
  Object.keys(downloadDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    downloadInfo[key] = downloadInfoLocalStorage[key]
      ? downloadInfoLocalStorage[key]
      : downloadDefaults[key];
  });

  // Include properties from localStorage
  Object.keys(downloadInfoLocalStorage).forEach((key) => {
    if (
      downloadInfo[key] === undefined &&
      downloadInfoLocalStorage[key] !== null
    )
      downloadInfo[key] = downloadInfoLocalStorage[key];
  });

  return downloadInfo;
};

const uploadInfoLocalStorage = localStorage.getItem('uploadInfo') || {};

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUploadInfo = () => {
  const uploadInfo = {};

  //console.log('downloadInfoLocalStorage',downloadInfoLocalStorage);

  // Update property in user
  Object.keys(downloadDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    uploadInfo[key] = uploadInfoLocalStorage[key]
      ? uploadInfoLocalStorage[key]
      : uploadDefaults[key];
  });

  // Include properties from localStorage
  Object.keys(downloadInfoLocalStorage).forEach((key) => {
    if (uploadInfo[key] === undefined && uploadInfoLocalStorage[key] !== null)
      uploadInfo[key] = uploadInfoLocalStorage[key];
  });

  return uploadInfo;
};

const exportInfoLocalStorage = localStorage.getItem('exportInfo') || {};
const exportReplenishmentInfoLocalStorage =
  localStorage.getItem('exportReplenishmentInfo') || {};

// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getExportInfo = () => {
  const exportInfo = {};

  //console.log('downloadInfoLocalStorage',downloadInfoLocalStorage);

  // Update property in user
  Object.keys(downloadDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    exportInfo[key] = exportInfoLocalStorage[key]
      ? exportInfoLocalStorage[key]
      : exportDefaults[key];
  });

  // Include properties from localStorage
  Object.keys(downloadInfoLocalStorage).forEach((key) => {
    if (exportInfo[key] === undefined && exportInfoLocalStorage[key] !== null)
      exportInfo[key] = exportInfoLocalStorage[key];
  });

  return exportInfo;
};
const getExportReplenishmentInfo = () => {
  const exportInfo = {};

  //console.log('downloadInfoLocalStorage',downloadInfoLocalStorage);

  // Update property in user
  Object.keys(exportReplenishmentDefaults).forEach((key) => {
    // If property is defined in localStorage => Use that
    exportInfo[key] = exportReplenishmentInfoLocalStorage[key]
      ? exportReplenishmentInfoLocalStorage[key]
      : exportReplenishmentDefaults[key];
  });

  // Include properties from localStorage
  Object.keys(downloadInfoLocalStorage).forEach((key) => {
    if (
      exportInfo[key] === undefined &&
      exportReplenishmentInfoLocalStorage[key] !== null
    )
      exportInfo[key] = exportReplenishmentInfoLocalStorage[key];
  });

  return exportInfo;
};

// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = function (query) {
    return window.matchMedia(query).matches;
  };

  if ('ontouchstart' in window || window.DocumentTouch) {
    return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join(
    ''
  );
  return mq(query);
};

/**
 * Checks display banner is active or not
 * @param {Boolean} [isEnabled] should be set true if banner needs to be shown
 * @returns
 */
const checkBannerStatus = (isEnabled = false) => {
  if (!isEnabled) {
    localStorage.removeItem('isBannerShown');
    return true;
  }

  const isBannerShown = localStorage.getItem('isBannerShown');

  if (isBannerShown === 'true') return true;

  return false;
};

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

export default async () => {
  let selectedStore = null;
  let userInfoLocalStorage = await localForage.getItem('userInfo');
  if (userInfoLocalStorage && userInfoLocalStorage.user) {
    selectedStore =
      userInfoLocalStorage.user.store.find(
        (element) =>
          element.marketplaceName === marketplace && element.storeId === store
      ) || null;
  }

  return {
    isExternalTrail: false,
    AppActiveUser: await getUserInfo(),
    AppActiveStoreTrial: getStoreTrialInfo(),
    AppActiveStoreFunding: getStoreFundingInfo(),
    AppActiveStoreLoan: getStoreLoanInfo(),
    AppActiveDownload: getDownloadInfo(),
    AppActiveUpload: getUploadInfo(),
    AppActiveExport: getExportInfo(),
    AppActiveReplenishmentExport: getExportReplenishmentInfo(),
    bodyOverlay: false,
    isVerticalNavMenuActive: true,
    is_touch_device: is_touch_device(),
    mainLayoutType: themeConfig.mainLayoutType || 'vertical',
    navbarSearchAndPinList,
    reduceButton: themeConfig.sidebarCollapsed,
    verticalNavMenuWidth: 'default',
    verticalNavMenuItemsMin: false,
    scrollY: 0,
    starredPages: navbarSearchAndPinList['pages'].data.filter(
      (page) => page.is_bookmarked
    ),
    theme: themeConfig.theme || 'dark',
    themePrimaryColor: colors.primary,
    version: {
      tokenVersion: versionJson && versionJson[0].tokenVersion,
      cssVersion: versionJson && versionJson[0].cssVersion,
    },
    // if we show banner, change this value : true
    // if we don't show banner, change this value: false
    isBannerShown: checkBannerStatus(false),
    isAdvertisingPrompt: localStorage.getItem('isAdvertisingPrompt'),

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    selectedStore,
    upgradeYourPlan: false,
    marketplaceTimeZone:
      JSON.parse(localStorage.getItem('marketplaceTimeZone')) || null,
    successfullyMarketplacesList: null,
    isSelectedAccountLevelExport: false,
    storeTenantID: null,
    isLanguagePreview:
      localStorage.getItem('isLanguagePreview') === 'true' || false,
    previousRoute: null,
    isConnectAccountRequested: false,
    isShowFreeTrialBanner: true,
    repricerUsable: true,
    dataStatusObject: {},
    dataStatusAllDataDownloaded: false,
    settingsDefaultTabId: 1,
  };
};
